import apis from "../../core/apis.js";

class CaptainAppResource {
  constructor($resource, Upload) {
    "ngInject";

    this.$resource = $resource;
    this.Upload = Upload;
  }

  getAll(options) {
    return this.$resource(apis.captainApp).get(options);
  }

  get(id) {
    return this.$resource(apis.captainApp + id).get();
  }

  search(search = "") {
    return this.$resource(apis.captainApp).get({ search });
  }

  post(item) {
    return this.$resource(apis.captainApp).save(item);
  }

  update(id, item) {
    return this.$resource(apis.captainApp + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  uploadWhiteListedCaptains(appVersionId, data) {
    const url = apis.captainApp + appVersionId + "/assign_captains";
    const request = this.Upload.upload({
      method: "POST",
      url,
      data,
    });
    return { $promise: request };
  }
}

export default CaptainAppResource;



// WEBPACK FOOTER //
// ./src/resources/captainApp/captainApp.resource.js